import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';

const TrustedClients = () => {
  const logos = [
    { name: "Brand 1", img: "/logo1.jpeg" },
    { name: "Brand 2", img: "/logo2.jpeg" },
    { name: "Brand 3", img: "/logo3.jpeg" },
    { name: "Brand 4", img: "/logo4.jpeg" },
    { name: "Brand 5", img: "/logo5.jpeg" },
    { name: "Brand 6", img: "/logo6.jpeg" },
    { name: "Brand 7", img: "/logo7.jpeg" },
    { name: "Brand 8", img: "/logo8.jpeg" },
    { name: "Brand 9", img: "/logo9.jpeg" },
    { name: "Brand 10", img: "/logo10.jpeg" },
    { name: "Brand 11", img: "/logo11.jpeg" },
    { name: "Brand 12", img: "/logo12.jpeg" },
    { name: "Brand 13", img: "/logo13.jpeg" },
  ];

  return (
    <section className="w-full py-8 md:py-20 bg-transparent relative z-10 overflow-hidden border-none select-none">
      
      {/* Dynamic Slide Zooming & Transition Styles */}
      <style>{`
        .trusted-swiper-container {
          padding: 30px 0 !important;
          overflow: visible !important;
        }
        .swiper-slide {
          display: flex;
          justify-content: center;
          align-items: center;
          height: auto;
        }
        .trusted-swiper-slide {
          width: 80px;
          height: 80px;
          border-radius: 9999px;
          border: 2px dashed rgba(63, 63, 70, 0.6); /* border-zinc-800 */
          background-color: rgba(24, 24, 27, 0.3); /* bg-zinc-900/30 */
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 10px;
          transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
          transform: scale(0.8);
          opacity: 0.35;
          filter: grayscale(100%);
        }
        @media (min-width: 640px) {
          .trusted-swiper-slide {
            width: 112px;
            height: 112px;
            padding: 14px;
          }
        }
        /* Zoom effect on center item */
        .swiper-slide-active .trusted-swiper-slide {
          transform: scale(1.22);
          opacity: 1;
          filter: grayscale(0%);
          border-style: solid;
          border-color: #F3CA52;
          box-shadow: 0 0 30px rgba(243, 202, 82, 0.3);
          background-color: rgba(24, 24, 27, 0.6);
        }
      `}</style>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Section Header */}
        <div className="text-center mb-8 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-[#F3CA52]/10 border border-[#F3CA52]/20 px-4 py-1.5 rounded-full mb-4">
            <span className="w-2 h-2 rounded-full bg-[#F3CA52] animate-pulse" />
            <span className="text-xs font-black text-[#F3CA52] uppercase tracking-[0.2em]">
              Our Network
            </span>
          </div>
          <p className="text-3xl sm:text-4xl font-black text-white tracking-tight">
            Trusted By Elite <span className="text-[#F3CA52]">Brands Worldwide</span>
          </p>
          <div className="w-16 h-[3px] bg-[#F3CA52] mx-auto mt-3 rounded-full" />
        </div>

        {/* 🎡 Swiper Carousel Wrapper with Edge Fading Blur */}
        <div className="relative w-full overflow-hidden bg-zinc-950/10 backdrop-blur-md border border-zinc-900/60 py-10 rounded-3xl shadow-2xl">

          {/* Edge Blending Shadow Masks */}
          <div className="absolute top-0 bottom-0 left-0 w-16 sm:w-36 bg-gradient-to-r from-black via-black/25 to-transparent z-20 pointer-events-none" />
          <div className="absolute top-0 bottom-0 right-0 w-16 sm:w-36 bg-gradient-to-l from-black via-black/25 to-transparent z-20 pointer-events-none" />

          {/* Swiper Slider */}
          <div className="px-6">
            <Swiper
              modules={[Autoplay]}
              loop={true}
              centeredSlides={true}
              autoplay={{
                delay: 1500,
                disableOnInteraction: false,
              }}
              speed={600}
              className="trusted-swiper-container"
              breakpoints={{
                0: {
                  slidesPerView: 3,
                  spaceBetween: 15,
                },
                768: {
                  slidesPerView: 5,
                  spaceBetween: 25,
                },
                1024: {
                  slidesPerView: 7,
                  spaceBetween: 35,
                }
              }}
            >
              {logos.map((logo, index) => (
                <SwiperSlide key={index}>
                  <div className="trusted-swiper-slide">
                    <img
                      src={logo.img}
                      alt={logo.name}
                      className="w-full h-full rounded-full object-cover transition-all duration-500"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

        </div>

      </div>
    </section>
  );
};

export default TrustedClients;